import MessageText from "./MessageText";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

const Messages = () => {
  const { id } = useParams();
  const chatWindowRef = useRef<HTMLDivElement>(null);

  const messagesState = useSelector(
    (state: RootState) => state.messages.messages
  );

  const endToEndMessages = messagesState.filter((item) => {
    return item.receiverId === (!id ? "1" : id);
  });

  useEffect(() => {
    if (chatWindowRef.current) {
      chatWindowRef.current.scrollTop = chatWindowRef.current.scrollHeight;
    }
  }, [endToEndMessages]);

  return (
    <div
      className="sm:h-full xl:h-[calc(700px_-_100px_-_65px)] 2xl:h-[calc(750px_-_100px_-_65px)] sm:px-2 md:px-6 pt-4 flex flex-col justify-end overflow-hidden overflow-y-scroll"
      ref={chatWindowRef}
    >
      <div className="w-full max-h-full grid gap-3 transition-all ease-in duration-500">
        {endToEndMessages.map((item, index) => (
          <MessageText key={index} isUser={true} data={item} />
        ))}
      </div>
    </div>
  );
};

export default Messages;
